var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticClass: "contentMonitoring", attrs: { row: "", wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", md3: "" } },
        [
          _c("wz-list-agents", {
            attrs: { agentSelect: _vm.selectedAgent, inMonitoring: true },
            on: {
              "update:agentSelect": function($event) {
                _vm.selectedAgent = $event
              },
              "update:agent-select": function($event) {
                _vm.selectedAgent = $event
              },
              chatSessionSelected: _vm.updateVisSelect
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "contentMonitoringInfosVisiteur",
          attrs: { xs12: "", sm6: "", md9: "" }
        },
        [
          _vm.selectAgent && _vm.visSelected
            ? _c("wz-view-chat", {
                attrs: {
                  datasViewPupitre: _vm.dataVisiteurComputed,
                  placesPupitre: 1,
                  selectedAgent: _vm.selectedAgent
                },
                on: { chatSessionSelect: _vm.updateVisSelect }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6057015a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6057015a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/trafic/Monitoring.vue
// module id = null
// module chunks = 